(function ($, Cobalt, undefined) {
    Cobalt.ForumManager = {
        newForumCount: 0,
        form: null,
        initialize: function () {
            Cobalt.ForumManager.form = $("form.j-forum-manager-form");

            Cobalt.ForumManager.form.ajaxForm({
                type: 'post',
                cache: false,
                beforeSubmit: function () {
                    Cobalt.ForumManager.form.mask();
                },
                success: function (data) {
                    setTimeout(function () { Cobalt.ForumManager.form.unmask() }, 500);
                }
            });

            if (Cobalt.ForumManager.form.length > 0) {
                var sortable = $('ol.sortable');
                sortable.nestedSortable({
                    disableNesting: 'no-nest',
                    forcePlaceholderSize: true,
                    handle: 'div.drag-handle .icon-drag-handle',
                    items: 'li',
                    opacity: .6,
                    placeholder: 'placeholder',
                    tabSize: 25,
                    tolerance: 'pointer',
                    toleranceElement: '> div',
                    stop: function (e, ui) {
                        var dragged = $(ui.item);
                        if (dragged.length == 0) {
                            return;
                        }
                        var forumID = dragged.attr("data-forum-id");
                        var parentForum = $("#field-parent-forum-" + forumID);
                        var oldParentForumID = parentForum.val();

                        // Determine the parent forum.
                        var parent = dragged.parents("li.forum-item").first();
                        var parentForumID = 0;
                        if (parent.length > 0) {
                            parentForumID = parent.attr("data-forum-id");
                        } else {
                            parentForumID = $(sortable[0]).attr("data-root-forum-id");
                        }

                        parentForum.val(parentForumID);

                        $(".icon[data-forum-id='" + forumID + "']").each(function (i, val) {
                            $(val).attr("data-parent-forum-id", parentForumID);
                        });

                        // Redo ordering.
                        dragged.siblings("li.forum-item").andSelf().each(function (i, val) {
                            var forumItem = $(val);
                            var displayOrder = $("#field-display-order-" + forumItem.attr("data-forum-id"));
                            if (displayOrder.length > 0) {
                                displayOrder.val(i);
                                forumItem.attr("data-display-order", i);
                                forumItem.find(".icon[data-forum-id='" + forumItem.attr("data-forum-id") + "']").each(function (j, icon) {
                                    $(icon).attr("data-display-order", i);
                                });
                            }
                        });

                        // Save the form
                        Cobalt.ForumManager.form.submit();
                    }
                });

                Cobalt.ForumManager.form.find(".icon-edit").click(function (e) {
                    e.preventDefault();

                    Cobalt.ForumManager.form.mask();
                    var forumID = $(this).attr("data-forum-id");
                    var parentForumID = $(this).attr("data-parent-forum-id") || 0;
                    var displayOrder = $(this).attr("data-display-order");
                    var that = $(this);
                    var listItem = that.parents("li[data-forum-id='" + forumID + "']");
                    $.ajax({
                        url: Cobalt.Routes.Instance.CPForumForm(parentForumID, displayOrder, { "forumID": forumID }),
                        cache: false,
                        success: function (results) {
                            var dialogContainer = $("<div/>");
                            var formWrapper = $("<div/>");
                            var form = $(results).find("form");
                            var table = listItem.find("table");
                            formWrapper.append(form);
                            dialogContainer.append(formWrapper);
                            var dialog = dialogContainer.dialog({
                                modal: true,
                                dialogClass: "forum-form-modal",
                                draggable: false,
                                resizable: false,
                                close: function (event, ui) {
                                    $(event.target).remove();

                                    Cobalt.ForumManager.form.unmask();
                                },
                                open: function () {
                                    Cobalt.ForumManager.form.unmask();
                                },
                                title: L.Global.Forums.EditForum()
                            });
                            $(dialog).parent().center({ sizeToWindow: true, maxWidth: 600, maxHeight: 500 });
                            Cobalt.triggerHtmlInsert($(dialog).parent());
                            form.attr("action", Cobalt.Routes.Instance.CPForumForm(parentForumID, displayOrder, { "forumID": forumID }));
                            form.ajaxForm({
                                type: 'post',
                                cache: false,
                                beforeSubmit: function () {
                                    form.find("#field-submit").attr("disabled", "disabled");
                                },
                                success: function (results) {
                                    dialog.dialog("close");
                                    self.location.reload();
                                },
                                error: function (XMLHttpRequest, textStatus, errorThrown) {
                                    $.log("TextStatus: " + textStatus + "; ErrorThrown: " + errorThrown);
                                }
                            });
                        }
                    });
                });

                Cobalt.ForumManager.form.find(".icon-add").click(Cobalt.ForumManager.addButtonClicked);
                $("#forums-sortable").find(".user-action-add-forum .button").click(Cobalt.ForumManager.addButtonClicked);

                var $seeDeletedCheckbox = Cobalt.ForumManager.form.find(".j-see-deleted");
                $seeDeletedCheckbox.change(function () {
                    var seeDeleted = $(this).is(":checked");
                    $.cookie("Cobalt.ForumManager.SeeDeleted", seeDeleted);
                    Cobalt.ForumManager.form.attr("data-see-deleted", seeDeleted);
                });

                var seeDeleted = $.cookie("Cobalt.ForumManager.SeeDeleted");
                if (seeDeleted == "true") {
                    $seeDeletedCheckbox.prop("checked", true);
                    $seeDeletedCheckbox.trigger("change");
                }

            }

            Cobalt.runOnHtmlInsert(function ($parent) {

                var canHaveForumUrl = $parent.find(".j-can-have-forum-url");
                canHaveForumUrl.change(function () {
                    var linkOutUrl = $parent.find("#form-field-linkout-url");

                    if (this.checked) {
                        linkOutUrl.show();
                        $("#form-field-can-have-threads, #form-field-can-have-threads input").hide();
                    }
                    else {
                        linkOutUrl.hide();
                        $("#form-field-can-have-threads, #form-field-can-have-threads input").removeClass("hide").show();
                    }
                });

                canHaveForumUrl.change();

            });
        },
        addButtonClicked: function (e) {
            e.preventDefault();
            Cobalt.ForumManager.form.mask();
            var forumID = $(this).attr("data-forum-id");
            var parentForumID = $(this).attr("data-forum-id");
            var that = $(this);
            var listItem = that.parents("li[data-forum-id='" + forumID + "']");

            var displayOrder = 0;
            $.ajax({
                url: Cobalt.Routes.Instance.CPForumForm(parentForumID, displayOrder),
                cache: false,
                success: function (results) {
                    var dialogContainer = $("<div/>");
                    var formWrapper = $("<div/>");
                    var form = $(results).find("form");
                    var table = listItem.find("table");
                    formWrapper.append(form);
                    dialogContainer.append(formWrapper);
                    var dialog = dialogContainer.dialog({
                        modal: true,
                        dialogClass: "forum-form-modal",
                        draggable: false,
                        resizable: false,
                        close: function (event, ui) {
                            $(event.target).remove();
                            Cobalt.ForumManager.form.unmask();
                        },
                        open: function () {
                            Cobalt.ForumManager.form.unmask();
                        },
                        title: L.Global.Forums.CreateForum()
                    });
                    $(dialog).parent().center({ sizeToWindow: true, maxWidth: 600, maxHeight: 500 });
                    Cobalt.triggerHtmlInsert($(dialog).parent());

                    form.ajaxForm({
                        type: 'post',
                        cache: false,
                        dataType: 'json',
                        beforeSubmit: function () {
                            form.find("#field-submit").attr("disabled", "disabled");
                        },
                        success: function (results) {
                            dialog.dialog("close");
                            self.location.reload();
                        },
                        error: function (XMLHttpRequest, textStatus, errorThrown) {
                            $.log("TextStatus: " + textStatus + "; ErrorThrown: " + errorThrown);
                        }
                    });
                }
            });
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.ForumManager.js